<!-- <div class="modal-header w-100 d-inline-block p-3 pb-0 mb-0 bg-white">
  <div id="myModal" class="modal">
    <div class="modal-content">
      <span class="close">&times;</span>
      <h1>Resend Booking Confirmation?</h1>
      <p>
        Are you sure you want to request for
        <strong>booking confirmation?</strong>
      </p>
      <div class="buttons">
        <button>No</button>
        <button id="">Resend Booking</button>
      </div>
      <div class="popup modal-header w-100 d-inline-block p-4 pb-0 mb-0">
        <div class="text-right w-100">
          <fa-icon [icon]="icons.cancel" class="icon"></fa-icon>
        </div>
        <h1>Cancel Booking?</h1>
        <p class="mb-5">
          Are you sure you want to request cancellation for this
          <span class="fw-bold">booking?</span>
        </p>
        <div class="mb-4 d-flex gap-3">
          <button class="btn btn-stripe w-50">No</button>
          <button class="btn w-50">Cancel Booking</button>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="popup modal-header w-100 d-inline-block  pb-0 mb-0">
  <div *ngIf="step1" class="p-4">
    <div class="text-right w-100" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
    <h1>Cancel Booking?</h1>

    <p class="mb-5">Are you sure you want to request cancellation for this
      <span class="fw-bold">booking?</span>
    </p>
    <div class="mb-4 d-flex  gap-3 resend">
      <button class="btn btn-stripe " (click)="bsModalRef?.hide()" >No</button>
      <button class="btn btn-resend " (click)="showNext()">Cancel Booking</button>
    </div>
  </div>
  <div *ngIf="cancelRequestSent" class="p-4">
    <div class="text-right w-100" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
    <img src="assets/images/Success.gif" class="success">
    <h1>Request Sent!</h1>
    <p class="mb-5">Your booking cancellation request has
      been sent. Our support team would get in touch shortly.
    </p>
    <div class="mb-4 d-flex  gap-3 resend">
      <button class="btn btn-resend w-100 " (click)="bsModalRef?.hide()">Done</button>
    </div>
  </div>
  <div *ngIf="showNextDisplay">
    <div class="d-flex justify-content-between align-items-center header">
      <p >Cancel Booking</p>
      <div class="text-right" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
    </div>
    <form class="" [formGroup]="cancelForm">

      <textarea name="" id="message" formControlName="message" placeholder="Kindly state your reason for cancelling this booking"> </textarea>
    </form>
    <div class="mb-4 d-flex  gap-3 resend">
      <!-- <button class="btn btn-stripe " (click)="bsModalRef?.hide()" >No</button> -->
      <button [disabled]="cancelForm.invalid" (click)="submitCancellation()" class="btn btn-resend w-100 " (click)="showNext()"> {{loading ? "Processing..." : "Cancel Booking"}} </button>
    </div>
  </div>
</div>
